module.exports = __webpack_public_path__ + "img/dashboard.b044dd13.jpg";